import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/packageTours', request)
}

export {get}
